import IslandLayout from "components/IslandLayout/IslandLayout";
import React from "react";

const DefaultChatRoom = () => {
  return (
    <IslandLayout>
      <div className="default_chat_room_container">
        <img
          src="https://images.veehive.ai/webApp/group_chat_default.png"
          className="group_chat_img"
        />
        <p className="chat_room_default_desc">
          Take a moment to choose a chatroom and unlock a world of connections.
          Join in and immerse yourself in thrilling conversations. Get ready for
          an exhilarating journey of shared interests and exciting encounters!
        </p>
      </div>
    </IslandLayout>
  );
};

export default DefaultChatRoom;
